import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import {
	faEnvelope as farEnvelope,
	faHandshake as farHandshake,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}
interface Props extends AbstractStepProps {
	finalAmount: number;
}
export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { finalAmount } = this.props;

		return (
			<>
				<Card.Header className="text-white text-center">
					<Card.Title as="div" className="h1 final-amount-title">
						{formatText(Math.floor(finalAmount), "ft")}
					</Card.Title>
					<Card.Title className="h4 text-uppercase">
						ennyi pénzed lesz
						<br />
						mire nyugdíjba mész
					</Card.Title>
				</Card.Header>
				<Card.Body className="py-2">
					<div className="mt-2 d-flex block-with-icon">
						<div className="text-center px-2">
							<FontAwesomeIcon icon={farEnvelope} className="text-gold" size="5x" />
						</div>
						<div className="pl-2 text-white text-block display-6">
							A részletes eredményedet
							<br /> <strong className="text-nowrap">e-mailben</strong> fogjuk elküldeni számodra!
						</div>
					</div>
					<hr className="my-2" />
					<div className="py-2">
						<strong>Szeretnéd megtudni:</strong>
					</div>
					<List itemStyle="tick" variant="gold">
						<List.Item>Hogyan lesz ennyi pénzed nyugdíjas éveidre?</List.Item>
						<List.Item>
							Hogy melyik számodra a legmegfelelőbb: nyugdíjpénztár, nyugdíjbiztosítás vagy NYESZ?
						</List.Item>
						<List.Item>Illetve, hogy mennyi állami támogatást kaphatsz?</List.Item>
					</List>
					<div className="row justify-content-center">
						<div className="d-flex mt-sm-4 align-items-center">
							<div className="icon border-right border-white pr-2">
								<FontAwesomeIcon icon={farHandshake} size="2xl" className="text-gold" />
							</div>
							<div className="text-white pl-2 h6">Bízd magad független szakértőinkre!</div>
						</div>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" variant="gold">
						Kérem a részletes eredményem!
					</Button>
				</Card.Footer>
			</>
		);
	}
	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}
	protected getComponentName(): string {
		return "Result";
	}
}
